import { colors } from '@chegg-ui/theme'
import { ThemedStyledProps } from 'styled-components'

const theme = {
  spacing: {
    xs: '5px',
    sm: '10px',
    md: '20px',
    lg: '25px',
    xl: '30px',
    md2: '15px',
    md3: '20px',
  },
  border: {
    colors: {
      ...colors,
    },
  },
  colors: {
    ...colors,
    BMBlue: '#103b57',
    CMRed: '#BF1905',
    orange: colors.cheggOrange, // breaks app if not here
    errorRed: '#E43F32',
    green4dc: '#4dc66d',
  },
  font: {
    heading: {
      size: {
        sm: '20px',
        md: '28px',
        lg: '32px',
      },
    },
    text: {
      size: {
        xs: '12px',
        sm: '14px',
        md: '16px',
        lg: '20px',
        xlg: '24px',
        ['2xl']: '32px',
        ['3xl']: '42px',
        ['4xl']: '48px',
      },
    },
    weight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extraBold: 800,
    },
  },
  space: [5, 10, 15, 20, 30],
}

export default theme

export type ThemeProps<P> = ThemedStyledProps<P, typeof theme>



// WEBPACK FOOTER //
// ./src/styled/theme.ts